module.exports = __webpack_public_path__ + "9048dfbe1663c2799beb67cb243a229b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/adobe_2023_chart.png
// module id = 1624
// module chunks = 0